export default __webpack_public_path__ + "static/media/Visa_Brandmark.a05453b4.png";